import { Dispatch, SetStateAction } from 'react';
import { Root } from 'react-dom/client';

type Props = {
    domElement: HTMLDivElement;
    appRoot: Root;
    closeAction: Dispatch<SetStateAction<boolean>>;
    persist?: boolean;
};

const closeReactModal = ({ domElement, appRoot, closeAction, persist = false }: Props): void => {
    closeAction(false);
    if (!persist) {
        appRoot.unmount();
        domElement.remove();
    }
    if (localStorage.getItem('enabled')) {
        localStorage.setItem('enabled', '');
    }
    if (localStorage.getItem('occupied')) {
        localStorage.setItem('occupied', 'false');
    }
};

export default closeReactModal;
